import React from 'react'
import { Link } from 'react-router-dom'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { useTranslation} from 'react-i18next';
import PharmacyHeading from '../PharmacyHeading';
import Heading from '../../Fashion/Heading';

const TopDepartments = (props) => {
    const { t, i18n } = useTranslation();
    let settings = {
        arrows: false,
        dots: true,
        margin: 30,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 6,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
            }
        },
        ]
    };
 
    return (
     
        <>
            <section id="pharmacy_categorie" className="ptb-100 slider_button_left_right">
                <div className="container">
                  
                    <Heading heading={t('departments')} para={t('departmentssubheading')}/>
                    <div className="row position-relative">
                        <div className="col-lg-12">
                            <Slider {...settings}>
                                {props.data.map((data, index) => (
                                    <div className="instgram_post" key={index}>
                                    <a>
                                      <div className="centerdiv">
                                      
                                            {/* <p className="team-title text-white">{data.title[i18n.language]}</p> */}
                                            <div className='team-title text-white small mb-3'>
                                            {data?.services?.map((item, i) => <>
                                                <Link to={{
                        pathname: `/treatments/${(data?.title?.en).replaceAll(' ', '-').toLowerCase()}/${i18n.language}`, state: {
                            service: item
                        }}} className="text-white d-block font14 mb-2" style={{textDecoration: 'underline'}}  key={i}>{item.title[i18n.language]}</Link>
                                                
                                            </>)}

                                            </div>
                                           
                                      </div>
                                      <img  src={process.env.REACT_APP_IMG_URL+data.icon} />
                                    </a>
                                    <p className="font-weight-bold text-center">{data.title[i18n.language]}</p>
                                  </div>
                        //             <div className="px-2 text-center" key={index}>
                        //                 <Link to={{pathname: `/department-details/${data.id}`, state: {
                        //     department: data
                        //   }}}>
                        //                 <div className="bg-departhome text-center  mb-2">
                                            
                        //                         <img src={process.env.REACT_APP_IMG_URL+data.icon} />
                                            
                        //                 </div>

                        //                 <p className='font-weight-light'>{data.title[i18n.language]}</p>
                        //                 </Link>
                                       
                        //             </div>
                                ))}
                            </Slider>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default TopDepartments